<template>
  <div>
    <base-title
      title="Juno"
      :subtitle="StringLanguage.integrations"
      link="integracoes"
    />

    <div class="integration-register">
      <div class="header">
        <div class="d-flex justify-between align-center w-100">
          <p class="title">Informações</p>
          <div class="toggle" @click="toggle()">
            <input
              type="checkbox"
              id="toggle-checkbox"
              v-model="formData.active"
            />

            <div
              class="toggle-control"
              :class="formData.active ? 'toggleOn' : 'toggleOff'"
            >
              <span class="control">
                <span>{{ formData.active ? 'Ativado' : 'Desativado' }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="form">
        <base-input
          :valid="!formErrors.privateToken"
          v-model="formData.privateToken"
          @input="(value) => removeEmptySpaces('privateToken', value)"
          placeholder="Token privado"
          class="w-100"
        />

        <base-input
          :valid="!formErrors.publicToken"
          v-model="formData.publicToken"
          @input="(value) => removeEmptySpaces('publicToken', value)"
          placeholder="Token público"
          class="w-100"
        />

        <base-input
          :valid="!formErrors.clientId"
          v-model="formData.clientId"
          @input="(value) => removeEmptySpaces('clientId', value)"
          placeholder="Client ID"
          class="w-100"
        />

        <base-input
          :valid="!formErrors.clientSecret"
          v-model="formData.clientSecret"
          @input="(value) => removeEmptySpaces('clientSecret', value)"
          placeholder="Secret"
          class="w-100"
        />
      </div>
    </div>

    <div class="options" v-if="!this.tokenConfiguration">
      <div class="container">
        <div class="content">
          <p>Ainda não tem cadastro com a Juno?</p>

          <a
            :href="getOnboardingLink()"
            target="_blank"
            noreferrer
            class="no-decoration"
          >
            <base-button class="big w-100">Cadastre-se agora</base-button>
          </a>
        </div>
      </div>
    </div>

    <div class="d-flex justify-end w-100" v-if="hasChanges()">
      <base-button design="save" @click="save" />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
// styles
import '@/assets/css/veasy/integrations.css';
// components
import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseInput from '@/components/Input.vue';
// mixin
import junoConfiguration from '@/mixins/junoConfiguration.js';
// api
import PaymentAPI from '@/api/payment.js';

export default {
  components: {
    BaseTitle,
    BaseButton,
    BaseInput,
  },
  mixins: [junoConfiguration],
  data() {
    return {
      formData: {
        privateToken: '',
        publicToken: '',
        clientId: '',
        clientSecret: '',
        active: true,
      },
      formErrors: {
        privateToken: false,
        publicToken: false,
        clientId: false,
        clientSecret: false,
        active: false,
      },
    };
  },
  beforeMount() {
    this.loadInitialInfo();
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasChanges()) {
      confirm(`${StringLanguage.confirmComplement}`, (res) => res && this.$store.dispatch('juno/cleanConfigurations') && next());
      return;
    }
    this.$store.dispatch('juno/cleanConfigurations');

    next();
  },
  methods: {
    loadInitialInfo() {
      if (!this.tokenConfiguration) {
        PaymentAPI.getJunoConfiguration().then((response) => {
          if (response.getErrors([]).length === 0) {
            const {
              credentials: {
                privateToken,
                publicToken,
                clientId,
                clientSecret,
              },
              active,
            } = response.getData({});
            this.formData.privateToken = privateToken;
            this.formData.publicToken = publicToken;
            this.formData.clientId = clientId;
            this.formData.clientSecret = clientSecret;
            this.formData.active = active;
          }
        });

        return;
      }

      this.formData.privateToken = this.tokenConfiguration.privateToken;
      this.formData.publicToken = this.tokenConfiguration.publicToken;
      this.formData.clientId = this.tokenConfiguration.clientId;
      this.formData.clientSecret = this.tokenConfiguration.clientSecret;
      this.formData.active = this.tokenConfiguration.active;
    },
    formIsValid() {
      let valid = true;
      const requiredFields = [
        'privateToken',
        'publicToken',
        'clientId',
        'clientSecret',
      ];
      const errors = ['', null, undefined];

      requiredFields.forEach((field) => {
        if (errors.includes(this.formData[field])) {
          this.formErrors[field] = true;
          valid = false;
        } else {
          this.formErrors[field] = false;
        }
      });

      return valid;
    },
    async save() {
      if (!this.formIsValid() && this.hasChanges()) {
        alert('Preencha todos os campos obrigatórios.');
        return;
      }

      await this.submitConfiguration();
    },
    async submitConfiguration() {
      const bodyToRequest = {
        credentials: {
          privateToken: String(this.formData.privateToken).trim(),
          publicToken: String(this.formData.publicToken).trim(),
          clientId: String(this.formData.clientId).trim(),
          clientSecret: String(this.formData.clientSecret).trim(),
        },
        active: this.formData.active,
      };

      try {
        const response = await PaymentAPI.putJunoConfiguration(bodyToRequest);

        if (response.getErrors([]).length > 0) {
          alert('Erro ao salvar as configurações');
          return;
        }

        this.$store.dispatch('juno/loadConfigurations');
        alert(StringLanguage.saveSuccess);
      } catch (error) {
        alert('Erro ao salvar as configurações');
      }
    },
    hasChanges() {
      if (this.tokenConfiguration) {
        return (
          JSON.stringify(this.tokenConfiguration) !==
          JSON.stringify(this.formData)
        );
      }

      return true;
    },
    toggle() {
      this.formData.active = !this.formData.active;
    },
    getOnboardingLink() {
      return process.env.VUE_APP_JUNO_ONBOARDING_LINK;
    },
    removeEmptySpaces(field, value) {
      this.formData[field] = String(value).replaceAll(' ', '');
    },
  },
};
</script>
